module.exports = import("https://esm.sh/three/examples/jsm/renderers/CSS2DRenderer.js");;